import { Rpc, type NotifyPayload } from '@dynamika/rpc-core/contracts';
import type { Handler } from '@dynamika/rpc-core/engine';
import { emitToForm } from '../helpers';
import { getPeer } from '../peer';

export const formRpcScheme = {
  handlers: {
    measurements: {
      onActivate: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Measurement.ACTIVATE, cb),
      onDeactivate: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Measurement.DEACTIVATE, cb),
      onLock: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Measurement.LOCK, cb),
      onUnlock: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Measurement.UNLOCK, cb),
      onDelete: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Measurement.DELETE, cb),
      onUpdate: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Measurement.UPDATE, cb),
      onScreenshotNA: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Measurement.SCREENSHOT_NA, cb),
      onShow: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Measurement.SHOW, cb),
      onHide: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Measurement.HIDE, cb),
      onScreenshot: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Measurement.SCREENSHOT, cb),
      onRemoveEntry: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Measurement.REMOVE_ENTRY, cb),
      onRemoveAllEntries: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Measurement.REMOVE_ALL_ENTRIES, cb),
    },
    calculate: {
      onRano: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Calculate.RANO, cb),
      onRecist: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Calculate.RECIST, cb),
      onFirstVisitScoring: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Calculate.FIRST_VISIT_SCORING, cb),
      onPreviousVisitScoring: (cb: Handler) =>
        getPeer().handle(Rpc.Methods.D7.Calculate.PREVIOUS_VISIT_SCORING, cb),
    },
  },
  listeners: {
    onNotify: (cb: (payload: NotifyPayload) => void) =>
      getPeer().on(Rpc.Events.Form.NOTIFY, cb as (payload: unknown) => void),
  },
  events: {
    measurementChanges: (payload: unknown) =>
      emitToForm(Rpc.Events.D7.MEASUREMENT_CHANGES, payload),
    seriesChanged: (payload: unknown) =>
      emitToForm(Rpc.Events.D7.SERIES_CHANGED, payload),
    segmentationChanged: (payload: unknown) =>
      emitToForm(Rpc.Events.D7.SEGMENTATION_CHANGED, payload),
    selectedLabels: (payload: unknown) =>
      emitToForm(Rpc.Events.D7.SELECTED_LABELS, payload),
    viewerBusy: (payload: unknown) => emitToForm(Rpc.Events.D7.VIEWER_BUSY, payload),
    updateForm: (payload: unknown) => emitToForm(Rpc.Events.D7.UPDATE_FORM, payload),
    fetchTaskDone: (payload: unknown) =>
      emitToForm(Rpc.Events.D7.FETCH_TASK_DONE, payload),
  },
};
